import React from "react";
import style from "./StatsDashbaordTable.module.css";
import PropTypes from "prop-types";

import StatsTableGym from "../../Components/StatsTableGym/StatsTableGym";
import AtheleteDetails from "../../Container/AthletesDetails/AthletesDetails";
import Billing from "../../Container/Billing/Billing";

import { roleEnum } from "../../assets/Js/roleEnum";
import { useUTCLocalConvertor } from "../../Hooks/UTCLocalConvertor";

export const StatsDashboardTable = ({
  paramId,
  userId,
  desiredRole,
  loggedInUserRole,
  tableData,
  isLoading,
}) => {
  const UTCLocal = useUTCLocalConvertor();

  return (
    <>
      {desiredRole === roleEnum.owner ? (
        <StatsTableGym tableData={tableData} isLoading={isLoading} />
      ) : desiredRole === roleEnum.athlete && (paramId || userId) ? (
        <div className="row container-fluid p-0 m-0">
          <div className={`col-lg-6 col-sm-12 dashboardTableSection`}>
            <AtheleteDetails
              athleteId={paramId || userId}
              loggedInUserRole={loggedInUserRole}
              desiredRole={desiredRole}
            />
          </div>
          <div
            className={`col-lg-6 col-sm-12 dashboardTableSection ${style.billingBox}`}
          >
            <Billing athelteId={paramId || userId} UTCLocal={UTCLocal} />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

StatsDashboardTable.propTypes = {
  userId: PropTypes.string,
  tableData: PropTypes.array,
  desiredRole: PropTypes.string,
  loggedInUserRole: PropTypes.string,
  isLoading: PropTypes.bool,
};
